import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const verifs = [
  { title: 'verif_1_title', desc: 'verif_1_desc', icon: 'ri-shield-check-line' },
  { title: 'verif_2_title', desc: 'verif_2_desc', icon: 'ri-government-line' },
  { title: 'verif_3_title', desc: 'verif_3_desc', icon: 'ri-building-2-line' },
  { title: 'verif_4_title', desc: 'verif_4_desc', icon: 'ri-star-line' },
  { title: 'verif_5_title', desc: 'verif_5_desc', icon: 'ri-chat-smile-2-line' },
];

export default function VerificationsOfficielles() {
  const { t } = useTranslation('blogchoisir');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  return (
    <section ref={ref} id="verif" className="scroll-mt-28">
      <h2 className={`font-manrope font-bold text-slate-primary text-xl md:text-2xl lg:text-3xl mb-4 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        {t('verif_h2')}
      </h2>
      <p className={`text-slate-primary/60 text-sm md:text-base mb-6 transition-all duration-1000 delay-100 ${
        isVisible ? 'opacity-100' : 'opacity-0'
      }`}>
        {t('verif_intro')}
      </p>

      <div className="space-y-5">
        {verifs.map((v, idx) => (
          <div
            key={idx}
            className={`flex gap-4 transition-all duration-700 ${
              isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
            }`}
            style={{ transitionDelay: `${idx * 100 + 150}ms` }}
          >
            <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-copper/10">
              <i className={`${v.icon} text-copper`} />
            </div>
            <div>
              <h4 className="font-manrope font-bold text-slate-primary text-sm md:text-base mb-1">
                {t(v.title)}
              </h4>
              <p className="text-slate-primary/60 text-sm leading-relaxed">{t(v.desc)}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}